import React from "react";
import Commend3ConfirmDialog from "./Commend3ConfirmDialog";
import { Commend3Model } from "../Types";
import {
  DELETE_CONFIRM_ACTION,
  DELETE_CONFIRM_TITLE,
  deleteConfirmBody,
} from "../Commend3Constants";

type DeleteModelDialogProps = {
  model: Commend3Model | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteModelDialog = ({
  model,
  deleting,
  onClose,
  onConfirm,
}: DeleteModelDialogProps) => (
  <Commend3ConfirmDialog
    isOpen={Boolean(model)}
    id="commend3-delete-dialog"
    title={DELETE_CONFIRM_TITLE}
    body={model ? deleteConfirmBody(model.name) : ""}
    actionLabel={DELETE_CONFIRM_ACTION}
    busyLabel="Deleting…"
    busy={deleting}
    danger
    onCancel={onClose}
    onConfirm={onConfirm}
  />
);

export default DeleteModelDialog;
